import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSortable } from '@dnd-kit/sortable'

import { sortableStyle } from './sortable'
import DragHandle from './DragHandle'
import CurriculumRow from './CurriculumRow'

const LessonRow = ({ lesson, selected, onSelect }) => {
  const { t } = useTranslation()
  const sortable = useSortable({ id: lesson.id })
  const video = !!lesson.vimeoEmbedUrl

  return (
    <CurriculumRow
      ref={sortable.setNodeRef}
      style={sortableStyle(sortable)}
      handle={<DragHandle small listeners={sortable.listeners} attributes={sortable.attributes} />}
      icon={<i className={video ? 'fa fa-play' : 'fa fa-file-text-o'} aria-hidden='true' />}
      iconVariant={video ? 'video' : 'reading'}
      title={lesson.title || t('certificationBuilder.curriculum.untitledLesson')}
      muted={!lesson.title}
      meta={t(video ? 'certificationBuilder.curriculum.video' : 'certificationBuilder.curriculum.reading')}
      badge={lesson.draft ? t('certificationBuilder.curriculum.draft') : undefined}
      selected={selected}
      onSelect={onSelect}
    />
  )
}

LessonRow.propTypes = {
  lesson: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    vimeoEmbedUrl: PropTypes.string,
    draft: PropTypes.bool.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default LessonRow
